import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SecurityDialogComponent } from '../header/dialogs/security-dialog/security-dialog.component';
import {FacadeService} from "../../shared/service-facade/facade.service";
import {Observable} from "rxjs";
import { Configuration } from 'src/app/shared/configuration.enum';

@Component({
  selector: 'app-information-security',
  templateUrl: './information-security.component.html',
  styleUrls: ['./information-security.component.scss']
})
export class InformationSecurityComponent implements OnInit {
  phoneNumber = "";
  phoneLink = "";
  isMobile$: Observable<boolean>;

  constructor(
    public dialog: MatDialog,
    private facade: FacadeService,
  ) {
    this.isMobile$ = this.facade.isMobile$;
   }

  private _config(key: Configuration): string {
    return this.facade.getConfigurationSetting(key);
  }

  ngOnInit(): void {
    this.phoneNumber = this._config(Configuration.CUSTOMER_SUPPORT_PHONE);
    this.phoneLink = `tel:${this.phoneNumber}`;
  }

  openDialog(event: any) {
    event.preventDefault();
    const dialogRef = this.dialog.open(SecurityDialogComponent, {
      panelClass: 'security-dialog',
      width: '100%',
      maxWidth: '664px',
      disableClose: true,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(async userRequestsCancel => {
      if (!userRequestsCancel) return;
    });

  }

}
